module.exports = __webpack_public_path__ + "static/media/erik-4row.8643915e.png";